import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles.scss";
import UserType from "./UserTypes";
import Name from "./Name";
import Email from "./Email";
import DateOfBirth from "./DateOfBirth";
import Gender from "./Gender";
import Location from "./Location";
import ContactInfo from "./ContactInfo";
import Interests from "./Interests";
import UserName from "./UserName";
import ArtistType from "./ArtistType";
import TwitterAuth from "./TwitterAuth";
import qs from "qs";
import { updateCurrentUser } from "../../../../api/users";
import { log_error } from "../../../../api";
import { updateCurrentUserRedux } from "../../../../api/helper";
import { uploadMedia } from "../../../../api/helper";
import { listCountries } from "../../../../api/location";
import moment from "moment";
import { sortBy } from "lodash";

export default ({ user }) => {
  let [loading, setLoading] = useState(false);
  let [error, setError] = useState([]);
  let [success, setSuccess] = useState(false);
  const [countries, setCountries] = useState([]);
  const [userType, setUserType] = useState(user.user_type);
  const [s3_object_key, set_S3_object_key] = useState(null);
  const [countryCode, setCountryCode] = useState((user && user.phone_number && user.phone_number.code) || "1");

  useEffect(() => {
    listCountries(["name", "alpha2Code", "callingCodes", "flag"]).then(({ data }) => {
      let countryList = data.data.map((c) => ({
        ...c,
        name: c.alpha2Code === "GB" ? "United Kingdom" : c.name,
      }));
      countryList = sortBy(countryList, (country_code) => +country_code);
      setCountries(countryList);
    });
  }, []);

  const setImageUrl = (imgUrl) => {
    set_S3_object_key(imgUrl);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      setLoading(true);
      setError(false);
      setSuccess("");
      let data = {};
      let formData = new FormData(e.target);
      for (let value of formData.entries()) {
        if (value[0].indexOf("[]") >= 0) {
          let arr = data[value[0]] || [];
          data = {
            ...data,
            [value[0]]: [...arr, value[1]],
          };
        } else data = { ...data, [value[0]]: value[1] };
      }

      // NOTE: delete phone number and country code field from the request body if its not present
      const phoneNumber = data["phone_number_attributes[number]"];
      if (!phoneNumber) {
        delete data["phone_number_attributes[code]"];
        delete data["phone_number_attributes[number]"];
      } else {
        data["phone_number_attributes[code]"] = countryCode;
      }

      if (phoneNumber && (phoneNumber.length < 10 || phoneNumber.length > 13)) {
        setError([
          {
            message: "Oops! You have entered invalid phone number. Please fix and try resubmitting your registration.",
          },
        ]);
        return false;
      }

      const address_1 = data["address_attributes[address1]"];
      if (address_1.length == 0) {
        setError([
          {
            message: "Oops! You have not entered address 1. Please fix and try resubmitting your registration.",
          },
        ]);
        return false;
      }

      // const address_2 = data["address_attributes[address2]"];
      // if (address_2.length == 0) {
      //   setError([{
      //     message: 'Oops! You have not entered address 2. Please fix and try resubmitting your registration.'
      //   }]);
      //   return false;
      // }

      const city = data["address_attributes[city]"];
      if (city.length == 0) {
        setError([
          {
            message: "Oops! You have not entered city. Please fix and try resubmitting your registration.",
          },
        ]);
        return false;
      }

      const zip = data["address_attributes[zip]"];
      if (zip.length == 0) {
        setError([
          {
            message: "Oops! You have not entered zip. Please fix and try resubmitting your registration.",
          },
        ]);
        return false;
      }

      if (
        data["date_of_birth"] &&
        data["date_of_birth"] !== user.date_of_birth &&
        moment().diff(moment(data["date_of_birth"], "MM/DD/YYYY"), "years") < 13
      ) {
        setError([
          {
            message: "SORRY, YOU NEED TO BE AT LEAST 13 YEARS OLD TO JOIN UNIFI MUSIC, BUT THANKS FOR CHECKING US OUT.",
          },
        ]);
        return false;
      } else {
        data["date_of_birth"] = moment(data["date_of_birth"]).format("DD/MM/YYYY");
      }

      const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ \-']+$/;
      if (!nameRegex.test(data["first_name"])) {
        setError([
          {
            message: "Oops! Your first name should use letters and dashes only. Please fix and try resubmitting your registration.",
          },
        ]);
        return false;
      }

      if (!nameRegex.test(data["last_name"])) {
        setError([
          {
            message: "Oops! Your last name should use letters and dashes only. Please fix and try resubmitting your registration.",
          },
        ]);
        return false;
      }

      if (!/^[A-Za-z0-9À-ÖØ-öø-ÿ \-/']+$/.test(data["username"])) {
        setError([
          {
            message: "Oops! Your Display Name should use only letters, numbers, spaces, slashes, dashes or apostrophes.",
          },
        ]);
        return false;
      }

      await updateCurrentUser({ user: qs.parse(data) });
      if (s3_object_key) {
        await uploadMedia(s3_object_key);
      }
      updateCurrentUserRedux();
      setSuccess("User profile has been successfuly updated.");
    } catch (error) {
      setError(log_error(error));
    } finally {
      const middle_col = document.getElementById("middle_col");
      if (middle_col) {
        middle_col.scrollTop = 0;
      }
      setLoading(false);
    }
  };

  const onUserTypeChanged = (e) => {
    const { value } = e.target;
    setUserType(value);
  };

  return (
    <div id="account-settings">
      <form onSubmit={onSubmit}>
        {error.length ? (
          <div className="alert alert-danger">
            <small>{error.map((e) => e.message).join(", ")}</small>
          </div>
        ) : success ? (
          <div className="alert alert-success">
            <small>{success}</small>
          </div>
        ) : null}

        <UserName loading={loading} user={user} setImageUrl={setImageUrl} />
        <UserType onUserTypeChanged={onUserTypeChanged} disabled={loading} user={user} />
        <TwitterAuth user={user} />
        <ArtistType disabled={loading} user={user} userType={userType} />
        <Email disabled={loading} user={user} />
        <Name disabled={loading} user={user} />
        <DateOfBirth disabled={loading} user={user} />
        <Gender disabled={loading} user={user} />
        <Location disabled={loading} user={user} countries={countries} />
        <ContactInfo disabled={loading} user={user} countries={countries} code={countryCode} setCode={setCountryCode} />
        <Interests disabled={loading} user={user} />

        <div className="form-row d-flex justify-content-center mt-5">
          <Link to="/">
            <button disabled={loading} type="reset" className="submit btn btn-outline-primary mr-3">
              Cancel
            </button>
          </Link>
          <button disabled={loading} type="submit" className="submit btn btn-primary">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};
